export function onlyUnique(array, key) {

    var unique = [];
    array.forEach(a=>{ 
        if( !unique.find(x=>x[key]==a[key]) ){
            unique.push(a)
        }
    })
     
    return unique;

}